import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const StyledFieldset = styled.fieldset `
  width: 100%;
  padding: 0 0 4.5rem 0;
  border: 0;

  ${({ noPadding }) => noPadding &&
    css `
      padding: 0;
    `};
`;
const StyledLegend = styled.legend `
  font-weight: 500;
  color: ${Colors.BLACK};
  font-size: ${rem(20)};
  margin: 0 0 1rem 0;
`;
export const Fieldset = ({ children, legend, noPadding = false, }) => (React.createElement(StyledFieldset, { noPadding: noPadding },
    legend ? React.createElement(StyledLegend, null, legend) : null,
    children));
export default Fieldset;
//# sourceMappingURL=index.js.map